module.exports = __webpack_public_path__ + "bc99baedc6818715e3edabab012d4371.jpg";